import {SafeAny} from '@/types';
import {http} from '@/utils';

export interface TabType {
  type: string;
  typeName: string;
  hide?: number[];
}

export const getTabs = () => {
  return http.post<null, TabType[]>('app/user/balance/types');
};

export const getList = (data: {
  pageNo: number | 1;
  pageSize?: number | 10;
  changeDesc: string;
  yearMonth: string;
  status?: number;
}) => {
  return http.post<null, SafeAny[]>('app/user/balance', data);
};

export const getRiskList = ({
  pageNo,
  changeDesc,
  yearMonth,
  status,
}: {
  pageNo: number;
  changeDesc: string | number;
  yearMonth: string;
  status?: number;
}) => {
  return http.post<null, SafeAny[]>('app/user/balance/riskOrder', {
    pageSize: 10,
    pageNo,
    changeDesc,
    yearMonth,
    status,
  });
};
